import React from 'react'
import JobsTableHeader from './JobsTable/JobsTableHeader'
import JobsTableRow from './JobsTable/JobsTableRow'
import { Empty } from 'antd'

function JobsTable(props) {
    const { data = [], reset } = props || {}
    return (
        <div className='JobsTable'>
            <div className="wrapTable">
                <table className='table mb-4'>
                    <JobsTableHeader />
                    <tbody>
                        {!!data.length ? data.map((i, index) => (
                            <JobsTableRow
                                key={`JobsTableRow_${index}`}
                                item={i}
                                reset={reset}
                            />
                        )) :
                            <tr>
                                <td colSpan={9}>
                                    <Empty />
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default JobsTable